import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { withTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./consultFilter.data.form";
import InputSelect from "../../../utils/InputSelect";
import { ORDER_TYPE, ORIGINS, DESTINIES } from "../../../../constants/index";
import InputDate from "../../../utils/InputDate";
import InputText from "../../../utils/InputText";
import {
  FilterContainer,
  FilterButton,
  ClearButton,
} from "./consultFilter.styled";

const ConsultFilterForm = (props) => {
  const { t, handleSubmit, filtered, onClean } = props;

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let index = 0; index < 5; index++) {
    years.push({
      code: currentYear - index,
      label: currentYear - index,
    });
  }

  // const [year, setYear] = useState({ value: currentYear, label: currentYear });

  return (
    <FilterContainer>
      <div className="accordion" id="orderFilter">
        <div className="accordion-item">
          <h2 className="accordion-header" id="flush-headingOne">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              {t("forms.evaluation.filter")}
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#orderFilter"
          >
            <div className="accordion-body">
              <form
                className="form-horizontal"
                onSubmit={handleSubmit}
                autoComplete="off"
              >
                <div className="row">
                  <div className="col-3">
                    <Field
                      id="year"
                      name="year"
                      labelField={t("forms.evaluation.labels.year")}
                      component={InputSelect}
                      placeholder=""
                      optionLabel="label"
                      optionValue="code"
                      options={years.map((item) => ({
                        ...item,
                        label: t(item.label),
                      }))}
                      classNamePrefix="dark"
                      addOptionEmpty
                      classNameContainer="flex-grow-1"
                    />
                  </div>
                  <div className="col-3">
                    <Field
                      id="name"
                      className="form-control"
                      labelField={t("forms.evaluation.labels.nameSurname")}
                      name="name"
                      component={InputText}
                      fieldType="text"
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12 d-flex justify-content-end">
                    <FilterButton type="submit" className="me-2">
                      <i className="fas fa-search"></i>
                    </FilterButton>
                    <ClearButton
                      type="button"
                      onClick={() => onClean(props.resetForm)}
                      title={t("cleanFilter")}
                    >
                      <i className="fas fa-trash"></i>
                    </ClearButton>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </FilterContainer>
  );
};

ConsultFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  onClean: PropTypes.func,
  filtered: PropTypes.bool,
};

const ConsultFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "ConsultFilterForm",
})(withTranslation()(ConsultFilterForm));

export default ConsultFilterFormF;
